<template>
<b-card no-body>
  <validation-observer
    v-slot="{ handleSubmit }" ref="VForm"
  >
    <b-form @submit.prevent="handleSubmit($parent.doSubmitCRUD())">
      <b-card-header>
        <b-row>
          <b-col lg="8">
            <h5 class="card-title">{{ $parent.isAdd?'Add':'Edit' }} {{ $parent.pageTitle }}</h5>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col lg="4">
            <b-form-group>
              <label>Category <span class="text-danger">*</span></label>
              <v-select :options="$parent.mrCategory" v-model="row.af_afc_id" :reduce="v => v.value" />

              <VValidate 
                name="Category" 
                v-model="row.af_afc_id" 
                :rules="mrValidation.af_afc_id" 
              />
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group>
              <label>Question<span class="text-danger mr5">*</span></label>
              <b-form-input v-model="row.af_question" placeholder="e.g Bagaimana cara melakukan pembelian/pemesanan barang?"></b-form-input>                  
              <VValidate 
                name="Question" 
                v-model="row.af_question" 
                :rules="mrValidation.af_question" 
              />
            </b-form-group>            
          </b-col>

          <b-col lg="6">
            <b-form-group>
              <label>Answer<span class="text-danger mr5">*</span></label>
              
              <CKEditor :value.sync="row.af_answer" />

              <VValidate 
                name="Answer" 
                v-model="row.af_answer" 
                :rules="mrValidation.af_answer" 
              />
            </b-form-group>
          </b-col>

          <div class="w-100"></div>

          <b-col lg="6">
            <b-form-group class="mt-3">
              <label>Status<span class="text-danger mr5">*</span></label>
              <b-form-radio-group
                :options="Config.mr.StatusOptions"
                v-model="row[$parent.statusKey]"
              />
              <VValidate 
                name="Status" 
                v-model="row[$parent.statusKey]"
                :rules="{required:1}" 
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer>
        <b-row>
          <b-col lg="12" class="text-right">
            <button @click="$router.back()" type="button" class="btn  btn-rounded  btn-default mr-3">Cancel</button>
            <b-button type="submit" variant="primary" class="btn-rounded" @click="$parent.doSubmitCRUD('VForm', $refs)">Save Changes</b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-form>
  </validation-observer>
</b-card>
</template>

<script>
import CKEditor from "@/components/CKEditor.vue"

const _ = global._

export default {
  components: { CKEditor },
  props:{
    row:Object,
    mrValidation:Object,
    Config:Object,
    mrMenuRel:Array,
  },
  data() {
    return {
    }
  },
  computed:{
    isEmptyHakAkses(){
      if(!(this.row.bul_menu_role||[]).length) return true
      const dtEmpty = _.filter(this.row.bul_menu_role, v=>{
        return !Object.keys(v).length
      })
      return !!dtEmpty.length
    }
  },
  methods:{
    doSubmitForm(){
      this.$emit('click:doSubmit', 'VForm', this.$refs)
    },
    isEqual(p1, p2){
      if(p1 == p2) return true
      return false
    },
    setOverflowAuto(){
      document.querySelector('.page-wrapper').style.overflow = 'auto'
    },
    setOverflowHidden(){
      document.querySelector('.page-wrapper').style.overflow = 'hidden'
    },
  }
}
</script>